import { themeQuartz, iconSetQuartzLight } from "ag-grid-community";
import "../assets/styles/AgGrid.css";

/**
 * Custom AG Grid theme based on the Quartz theme with customizations.
 *
 * This theme follows the design specifications from the theme builder
 * and can be used across all AG Grid instances in the application.
 *
 * Usage:
 *   import myCustomTheme from '../../common/AgGridTheme';
 *
 *   <AgGridReact
 *     theme={myCustomTheme}
 *     // other props
 *   />
 */

const themeParams = {
  // Core colors
  accentColor: "#4F39F6",
  backgroundColor: "#ffffff",
  borderColor: "#7B818A26",
  foregroundColor: "rgb(46, 55, 66)",

  // Border styles
  borderRadius: 3,
  columnBorder: false,
  rowBorder: false,
  headerRowBorder: true,
  wrapperBorder: true,
  wrapperBorderRadius: 15,
  sidePanelBorder: true,

  // Typography
  fontFamily: ["ui-sans-serif", "system-ui"], // Tailwind sans stack
  fontSize: 13,
  headerFontSize: 12,
  headerFontWeight: 600,
  headerTextColor: "#4B5563", // gray-600 - matches UI guidelines for secondary text

  // Row styling
  rowHeight: 48,
  oddRowBackgroundColor: "#F9FAFB",
  selectedRowBackgroundColor: "#E0E7FF", // Light indigo for selection
  rowHoverColor: "#EEF2FF", // Tailwind indigo-50 for hover effect
  rowGroupBackgroundColor: "#ffffff", // Make row group headers white

  // Header styling
  headerBackgroundColor: "#F9FAFB",
  headerVerticalPaddingScale: 2,
  headerColumnSeparatorColor: "rgba(229, 231, 235, 0.5)", // Light gray separator

  // Cell styling
  cellHorizontalPadding: 16,
  cellVerticalPadding: 12,

  // Panel styling
  sideBarBackgroundColor: "#FFFFFF",

  // Spacing
  spacing: 8,

  // Checkbox styling
  checkboxCheckedColor: "#4F39F6",

  // Filter and menu styling
  menuBackgroundColor: "#FFFFFF",
  inputBackgroundColor: "#FFFFFF",
  inputBorderColor: "#D1D5DB",

  // Icon colors
  iconColor: "#6B7280",

  // Chart colors
  chartBackgroundColor: "#FFFFFF",

  // Other components
  inputBorderColorFocus: "#4F39F6",
  checkboxUncheckedColor: "#D1D5DB",
};

export const getAgGridTheme = () => {
  console.log("Theme created with parameters:", themeParams);
  return themeQuartz.withPart(iconSetQuartzLight).withParams(themeParams);
};
